export enum SequenceSuffixType {
    SEQUENCE_TIMESTAMP = 'SEQUENCE_TIMESTAMP',
    SEQUENCE_NUMBER = 'SEQUENCE_NUMBER'
}
